import { Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { IPaymentProvider } from '@web/dtos';

@Injectable({
  providedIn: 'root',
})
export class MockPaymentProviderStore {
  readonly isLoading: Signal<boolean> = signal(false);
  readonly paymentProviders: WritableSignal<IPaymentProvider[]> = signal([]);

  getThumbnailPath(id: string | undefined): string {
    return id ? `/images/payment-providers/${id}.svg` : '';
  }

  buy() {}

  buyOnDemand() {}

  cancel() {}

  getPaymentMethods() {}

  addPaymentMethods() {}

  deletePaymentMethods(paymentMethodId: string) {}
}
